import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";
import EN from "./assets/i18n/translations/en.json";
import FR from "./assets/i18n/translations/fr.json";

const resources = {
  en: {
    translation: EN
  },
  fr: {
    translation: FR
  }
};


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.ENV === "development",
  });

// L'app ne gère que deux locales : "fr-FR" et "en-EN" (convention utilisée
// partout via i18n.language === "fr-FR" / "en-EN", + sélecteur du NavBar).
// Or le LanguageDetector renvoie le code du navigateur ("en-US", "fr", "de-DE"…),
// qui ne correspond ni au drapeau ni aux <option> → d'où FR affiché sans drapeau.
// On normalise donc toute langue détectée vers l'une des deux locales gérées :
// tout ce qui commence par "fr" → "fr-FR" (France), sinon → "en-EN" (reste du monde).
const normalizeLng = (lng) =>
  (lng || "").toLowerCase().startsWith("fr") ? "fr-FR" : "en-EN";

// Synchronise l'attribut <html lang> avec la langue réellement affichée.
// Indispensable pour que la traduction automatique de Google/Chrome parte de
// la bonne langue source (sinon elle massacre noms propres, casse, etc.).
const syncHtmlLang = (lng) => {
  const base = (lng || "fr").toLowerCase().startsWith("fr") ? "fr" : "en";
  document.documentElement.setAttribute("lang", base);
};

i18n.on("languageChanged", syncHtmlLang);

const wantedLng = normalizeLng(i18n.language);
if (i18n.language !== wantedLng) {
  i18n.changeLanguage(wantedLng);
} else {
  syncHtmlLang(i18n.language);
}

export default i18n;